import {DialogFragment, PageFragment, PageFragmentProps} from "@/shared/PageFragment";
import {Box} from "@mui/material";
import {FormGenContainer, FormGenContainerMode} from "@/shared/FormGenContainer";
import {DW_LG} from "@/shared/dimens";
import {BaseApp, DIALOG_FLAG_DISABLE_BACKDROP_CLICK, DIALOG_FLAG_SHOW_CLOSE} from "@/shared/BaseApp";
import React from "react";
import {ExpenseType, ExpenseTypes, PracticeData} from "../types";

export class EditExpenseTypeHelper {

  static addExpenseType() {
    BaseApp.CONTEXT.showDialog(
      {flags: DIALOG_FLAG_SHOW_CLOSE | DIALOG_FLAG_DISABLE_BACKDROP_CLICK},
      () => <EditExpenseTypeFragment
        onExpenseTypeSaved={expenseType => BaseApp.CONTEXT.hideDialog()}/>);
  }

  static editExpenseType(expenseType: ExpenseType) {
    BaseApp.CONTEXT.showDialog(
      {flags: DIALOG_FLAG_SHOW_CLOSE | DIALOG_FLAG_DISABLE_BACKDROP_CLICK},
      () => <EditExpenseTypeFragment
        onExpenseTypeSaved={expenseType => BaseApp.CONTEXT.hideDialog()}
        edit={expenseType}/>);
  }
}

type EditExpenseTypeFragmentProps = PageFragmentProps & {
  onExpenseTypeSaved: (expenseType: ExpenseType) => void,
  edit?: ExpenseType,
}

class EditExpenseTypeFragment extends DialogFragment<EditExpenseTypeFragmentProps> {

  private readonly expenseTypes: ExpenseTypes;
  private readonly expenseType: ExpenseType;

  constructor(props: EditExpenseTypeFragmentProps, context: any) {
    super(props, context);
    this.expenseTypes = PracticeData.provider().presets.expenseTypes;
    if (props.edit) {
      this.expenseType = props.edit;
    } else {
      this.expenseType = ExpenseType.createNew();
    }
  }

  protected onCreateState() {
    return {
      ...super.onCreateState(),
      title: !Boolean(this.props.edit) ? "Add Expense Type" : "Edit Expense Type",
    };
  }

  protected styleFlags(): number {
    return PageFragment.STYLE_ACTION_PANEL_TYPE_BUTTON_FLAG;
  }

  protected getActionButtonText(): string {
    return "Save";
  }

  onActionButtonClicked() {
    this.addExpenseType().then(() => this.props.onExpenseTypeSaved(this.expenseType));
  }

  private async addExpenseType() {
    await this.expenseTypes.addListItem(this.expenseType);
  }

  renderContent(): React.ReactElement | null {
    return <Box style={{display: "flex", width: "84dvw", maxWidth: DW_LG}}>
      <FormGenContainer
        mode={!Boolean(this.props.edit) ? FormGenContainerMode.CREATE : FormGenContainerMode.EDIT}
        content={this.expenseType}
        saveActionButtonProvider={this}
      />
    </Box>;
  }
}
